import { Grid, Typography } from "@mui/material";
import React from "react";
import { useDateUtils } from "../../../utils/formatTime";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";

export default function MiscellaneousComp({
  selectedFilter,
  SelectedCardData,
  fromDate,
  toDate,
  monthName,
  selectedYear,
}) {
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
  const userRole=localStorage.getItem('userRole')

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.enquiry_id?.first_name || ""} ${
          params?.row?.enquiry_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div
          style={{
            color: "#0096FF",

            cursor: "pointer",
            "&:hover": {
              textDecoration: "none",
            },
          }}
          onClick={() =>
            window.open(
              `/enquirydetails/${params?.row.enquiry_id.id}`,
              "_blank"
            )
          }
        >
          {" "}
          {`${
            params?.row?.enquiry_id?.first_name
              ? params?.row?.enquiry_id?.first_name
              : ""
          } ${
            params?.row?.enquiry_id?.last_name
              ? params?.row?.enquiry_id?.last_name
              : ""
          }`}{" "}
        </div>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row?.enquiry_id?.mobile || "",
      renderCell: (params) => <div>{params.row?.enquiry_id?.mobile_country_code}

      {userRole === "advisor" || userRole === "trainer"
        ? params.row?.enquiry_id?.mobile?.replace(/.(?=.{4,}$)/g, "*")
        : params.row?.enquiry_id?.mobile}</div>,
    },
    {
      field: "branch_collected_by",
      headerName: "Branch",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",

      renderCell: (params) => <div>{params?.row?.branch_collected_by?.branch_name }</div>,
    },
    {
      field: "test_type_id",
      headerName: "Test Type",
      flex: 1,
      minWidth: 200,
      headerClassName: "header-cell",

      renderCell: (params) => <div>{params?.row?.test_type_id?.name }</div>,
    },
    {
      field: "revenue_amount",
      headerName: "Revenue",
      flex: 1,
      headerClassName: "header-cell",
      minWidth: 150,
    },

    {
      field: "created_date",
      headerName: "Created Date",
      flex: 1,
      minWidth: 100,
      headerClassName: "header-cell",
    },
    {
      field: "collected_by",
      headerName: "Collected By",
      flex: 1,
      minWidth: 150,
      headerClassName: "header-cell",

      renderCell: (params) => (
        <div>
          {params?.row?.collected_by?.first_name}{" "}
          {params?.row?.collected_by?.last_name}
        </div>
      ),
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {selectedFilter === "today" && (
          <Typography variant="h4" textAlign="center">
            Today ({currentDate})
          </Typography>
        )}
        {selectedFilter === "currentweek" && (
          <Typography variant="h4" textAlign="center">
            This Week ({weekRange})
          </Typography>
        )}

        {selectedFilter === "currentmonth" && (
          <Typography variant="h4" textAlign="center">
            {currentMonthName} {currentYear}
          </Typography>
        )}

        {selectedFilter === "custom" && (
          <Typography variant="h4" textAlign="center">
            {fromDate} - {toDate}
          </Typography>
        )}

        {selectedFilter === "default" && (
          <Typography variant="h4" textAlign="center">
            {monthName} {selectedYear}
          </Typography>
        )}
      </Grid>

      <Grid item xs={12}>
        <DataGrid
          rows={SelectedCardData}
          columns={columns}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          autoHeight
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          pageSizeOptions={[25, 50, 100]}
        />
      </Grid>
    </Grid>
  );
}
